var customerAnswers = {};
var answers = {
  "a": `
    
    <div class='answer__text-container'>
      <p>Your perfect shade of red hair extensions is: LIGHT AUBURN, STRAWBERRY BLONDE, CINNAMON SWIRL</p>
      <div class='img_container'>
        <a href='/collections/light-auburn-hair-extensions-30'>
          <img src='https://cdn.shopify.com/s/files/1/0069/6470/7389/files/red3.jpg?v=1664530220' loading='lazy' height='400' width='400' alt=''>
          <p>LIGHT AUBURN</p>
        </a>

        <a href='/collections/strawberry-ginger-blonde-hair-extensions-27'>
          <img src='https://cdn.shopify.com/s/files/1/0069/6470/7389/files/red1.jpg?v=1664530220' loading='lazy' height='400' width='400' alt=''>
          <p>STRAWBERRY BLONDE</p>
        </a>

        <a href='/collections/cinnamon-blonde-27-30-hair-extensions'>
          <img src='https://cdn.shopify.com/s/files/1/0069/6470/7389/files/red2.jpg?v=1664530220' loading='lazy' height='400' width='400' alt=''>
          <p>CINNAMON SWIRL</p>
        </a>
      </div>
      <p>Note: This quiz provides general suggestions based on the provided content and may not be accurate for every individual. Always consult with a professional stylist for the best results. If you need help choosing the correct shade, let us help you with our <a href='https://www.cliphair.co.uk/pages/colour-matching-service' title='colour match'>free colour match</a> service.</p>
    </div>`,
  "b":`

    <div class='answer__text-container'>
      <p>Your perfect shade of red hair extensions is: DARK AUBURN, AUTUMN SPICE, CHERRY RED</p>
      <div class='img_container'>
        <a href='/collections/dark-auburn-copper-red-hair-extensions-33'>
          <img src='https://cdn.shopify.com/s/files/1/0069/6470/7389/files/red4.jpg?v=1664530220' loading='lazy' height='400' width='400' alt=''>
          <p>DARK AUBURN</p>
        </a>

        <a href='/collections/autumn-spice-hair-extensions-30b'>
          <img src='https://cdn.shopify.com/s/files/1/0069/6470/7389/files/color-autumn-spice-30b.png?v=1692181354' loading='lazy' height='400' width='400' alt=''>
          <p>AUTUMN SPICE</p>
        </a>

        <a href='/collections/plum-cherry-red-hair-extensions-530'>
          <img src='https://cdn.shopify.com/s/files/1/0069/6470/7389/files/red6.jpg?v=1664530220' loading='lazy' height='400' width='400' alt=''>
          <p>CHERRY RED</p>
        </a>
      </div>
      <p>Note: This quiz provides general suggestions based on the provided content and may not be accurate for every individual. Always consult with a professional stylist for the best results. If you need help choosing the correct shade, let us help you with our <a href='https://www.cliphair.co.uk/pages/colour-matching-service' title='colour match'>free colour match</a> service.</p>
    </div>`,
  "c":`

    <div class='answer__text-container'>
      <p>Your perfect shade of red hair extensions is: BRIGHT RED, CHERRY RED, MAHOGANY, FLAMING GINGER</p>
      <div class='img_container'>
        <a href='/collections/bright-red-hair-extensions'>
          <img src='https://cdn.shopify.com/s/files/1/0069/6470/7389/files/red9.jpg?v=1664530220' loading='lazy' height='400' width='400' alt=''>
          <p>BRIGHT RED</p>
        </a>

        <a href='/collections/mahogany-red-hair-extensions-99j'>
          <img src='https://cdn.shopify.com/s/files/1/0069/6470/7389/files/red8.jpg?v=1664530220' loading='lazy' height='400' width='400' alt=''>
          <p>MAHOGANY</p>
        </a>

        <a href='/collections/ginger-natural-red-hair-extensions-350'>
          <img src='https://cdn.shopify.com/s/files/1/0069/6470/7389/files/red5.jpg?v=1664530220' loading='lazy' height='400' width='400' alt=''>
          <p>FLAMING GINGER</p>
        </a>
      </div>
      <p>Note: This quiz provides general suggestions based on the provided content and may not be accurate for every individual. Always consult with a professional stylist for the best results. If you need help choosing the correct shade, let us help you with our <a href='https://www.cliphair.co.uk/pages/colour-matching-service' title='colour match'>free colour match</a> service.</p>
    </div>`,
  "d":`

    <div class='answer__text-container'>
      <p>Your perfect shade of red hair extensions is: FLAMING GINGER, STRAWBERRY BLONDE, LIGHT AUBURN</p>
      <div class='img_container'>
        <a href='/collections/ginger-natural-red-hair-extensions-350'>
          <img src='https://cdn.shopify.com/s/files/1/0069/6470/7389/files/red5.jpg?v=1664530220' loading='lazy' height='400' width='400' alt=''>
          <p>FLAMING GINGER</p>
        </a>
        
        <a href='/collections/strawberry-ginger-blonde-hair-extensions-27'>
          <img src='https://cdn.shopify.com/s/files/1/0069/6470/7389/files/red1.jpg?v=1664530220' loading='lazy' height='400' width='400' alt=''>
          <p>STRAWBERRY BLONDE</p>
        </a>

        <a href='/collections/light-auburn-hair-extensions-30'>
          <img src='https://cdn.shopify.com/s/files/1/0069/6470/7389/files/red3.jpg?v=1664530220' loading='lazy' height='400' width='400' alt=''>
          <p>LIGHT AUBURN</p>
        </a>

      </div>
      <p>Note: This quiz provides general suggestions based on the provided content and may not be accurate for every individual. Always consult with a professional stylist for the best results. If you need help choosing the correct shade, let us help you with our <a href='https://www.cliphair.co.uk/pages/colour-matching-service' title='colour match'>free colour match</a> service.</p>
    </div>`,
  "e":`

    <div class='answer__text-container'>
      <p>Your perfect shade of red hair extensions is: AUTUMN SPICE, DEEP RED, CHERRY RED, BRIGHT RED</p>
      <div class='img_container'>
        <a href='/collections/autumn-spice-hair-extensions-30b'>
          <img src='https://cdn.shopify.com/s/files/1/0069/6470/7389/files/color-autumn-spice-30b.png?v=1692181354' loading='lazy' height='400' width='400' alt=''>
          <p>AUTUMN SPICE</p>
        </a>
        
        <a href='/collections/deep-red-hair-extensions'>
          <img src='https://cdn.shopify.com/s/files/1/0069/6470/7389/files/red7.jpg?v=1664530220' loading='lazy' height='400' width='400' alt=''>
          <p>DEEP RED</p>
        </a>

        <a href='/collections/plum-cherry-red-hair-extensions-530'>
          <img src='https://cdn.shopify.com/s/files/1/0069/6470/7389/files/red6.jpg?v=1664530220' loading='lazy' height='400' width='400' alt=''>
          <p>CHERRY RED</p>
        </a>

      </div>
      <p>Note: This quiz provides general suggestions based on the provided content and may not be accurate for every individual. Always consult with a professional stylist for the best results. If you need help choosing the correct shade, let us help you with our <a href='https://www.cliphair.co.uk/pages/colour-matching-service' title='colour match'>free colour match</a> service.</p>
    </div>`
}

function addAnswer(button){
  	let question = button.dataset.current;
	let answer = button.dataset.answer;
  	customerAnswers[question] = (answer);
}

function nextScreen(button){
	let currentId = button.dataset.current;
  	let nextId = button.dataset.next;
  	let screen = document.getElementById(nextId);
  
  	if (nextId == 'last'){
  		answerScreen()
  	}	
  	
  	screen.style.left = '0px';
    scrollToTop();
    setTimeout(() => { changePosition(currentId, nextId); }, 500)
    setTimeout(function () {
        document.getElementById(currentId).style.display = 'none';
    }, 1000)
    
}

function backScreen(button){
	let currentId = button.dataset.current;
  	let nextId = button.dataset.next;
  	let screen = document.getElementById(currentId);

    document.getElementById(nextId).style.display = 'block';
    screen.style.left = '-9999px';
    scrollToTop();
    changePosition(currentId, nextId);
}

function answerScreen(){

  let answerA = 0;
  let answerB = 0;
  let answerC = 0;
  let answerD = 0;
  let answerE = 0;
  let answerText = "";

  for(let i = 1; i <= Object.keys(customerAnswers).length; i++){
    let answer = customerAnswers["q" + i];
    switch(answer){
      case "a":
        answerA += 1;
        break;
      case "b":
        answerB += 1;
        break;
      case "c":
        answerC += 1;
        break;
      case "d":
        answerD += 1;
        break;
      case "e":
        answerE += 1;
        break;
    }
  }

  if(answerA >= answerB && answerA >= answerC && answerA >= answerD && answerA >= answerE){
    answerText = answers["a"]
  }else if(answerB >= answerA && answerB >= answerC && answerB >= answerD && answerB >= answerE){
    answerText = answers["b"]
  }else if(answerC >= answerA && answerC >= answerB && answerC >= answerD && answerC >= answerE){
    answerText = answers["c"]
  }else if(answerD >= answerA && answerD >= answerC && answerD >= answerB && answerD >= answerE){
    answerText = answers["d"]
  }else if(answerE >= answerA && answerE >= answerC && answerE >= answerB && answerE >= answerD){
    answerText = answers["e"]
  }

  let answerContainer = document.getElementById('answer');
  answerContainer.innerHTML = answerText;
}

function changePosition(current, next){
	let currentId = current;
  	let nextId = next;
  	
  	let currentScreen = document.getElementById(currentId);
    let nextScreen = document.getElementById(nextId);
    
    nextScreen.style.position = 'relative';
    nextScreen.style.opacity = 1 ;
    currentScreen.style.position = 'absolute';
    currentScreen.style.opacity = 0;
}

function scrollToTop() {
    document.body.scrollTop = 100; // For Safari
    document.documentElement.scrollTop = 100; // For Chrome, Firefox, IE and Opera
}